import { GrButton, GrTypography } from "@jnpmedi/grebob";
import { useHistory } from "react-router-dom";
import { InformationGuide } from "@newComponents/layout/InformationGuide";
import { MvnMessage } from "@newLibs/utils";
import { DOCS_COMMON_LANG } from "@maven-msg/lang/docs/common";

export function PageNotFoundLayout() {
  const history = useHistory();
  return (
    <InformationGuide
      style={{ height: "100vh", backgroundColor: "inherit" }}
      title={MvnMessage(DOCS_COMMON_LANG.NOT_FOUND_PAGE_TITLE)}
      description={MvnMessage(DOCS_COMMON_LANG.NOT_FOUND_PAGE_DESC)}
      emptyType="notFound"
      confirmButton={
        <GrButton onClick={() => history.replace("/")}>
          <GrTypography>{MvnMessage(DOCS_COMMON_LANG.GOTO_HOME_NOUN)}</GrTypography>
        </GrButton>
      }
    />
  );
}
